const SvgIcon = ({ size = '24', color = '#000' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 21.818 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeDasharray="none"
      strokeMiterlimit="4"
      strokeWidth="0.12"
      d="M15.273 0a1.09 1.09 0 0 0-1.091 1.09v2.183a1.09 1.09 0 0 0 1.09 1.09 1.09 1.09 0 0 0 1.092-1.09V1.09A1.09 1.09 0 0 0 15.273 0"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeDasharray="none"
      strokeMiterlimit="4"
      strokeWidth="0.12"
      d="M10.815 15.273c-4.204 0-7.636 3.432-7.636 7.636A1.09 1.09 0 0 0 4.269 24a1.09 1.09 0 0 0 1.092-1.09 5.44 5.44 0 0 1 5.454-5.455 5.44 5.44 0 0 1 5.455 5.454A1.09 1.09 0 0 0 17.36 24a1.09 1.09 0 0 0 1.092-1.09c0-4.205-3.432-7.637-7.637-7.637"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeDasharray="none"
      strokeMiterlimit="4"
      strokeWidth="0.12"
      d="M6.545 0a1.09 1.09 0 0 0-1.09 1.09v2.183a1.09 1.09 0 0 0 1.09 1.09 1.09 1.09 0 0 0 1.091-1.09V1.09A1.09 1.09 0 0 0 6.546 0"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeDasharray="none"
      strokeMiterlimit="4"
      strokeWidth="0.12"
      d="M10.91 6.545C7.91 6.545 5.454 9 5.454 12s2.455 5.455 5.454 5.455c3 0 5.455-2.455 5.455-5.455s-2.455-5.455-5.455-5.455m0 2.182A3.256 3.256 0 0 1 14.181 12a3.256 3.256 0 0 1-3.273 3.273A3.256 3.256 0 0 1 7.636 12a3.256 3.256 0 0 1 3.273-3.273"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeDasharray="none"
      strokeMiterlimit="4"
      strokeWidth="0.12"
      d="M3.273 2.182A3.29 3.29 0 0 0 0 5.455v15.272A3.29 3.29 0 0 0 3.273 24h15.272a3.29 3.29 0 0 0 3.273-3.273V5.455a3.29 3.29 0 0 0-3.273-3.273zm0 2.182h15.272c.624 0 1.091.467 1.091 1.09v15.273c0 .624-.467 1.091-1.09 1.091H3.272c-.624 0-1.091-.467-1.091-1.09V5.454c0-.624.467-1.091 1.09-1.091"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;
